import React from 'react';
import PropTypes from 'prop-types';

const Modal = ({ children, onClose }) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  React.useEffect(() => {
    const onEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [onClose]);

  const overlayStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: isMobile ? '10px' : '24px',
    overflowY: 'auto',
  };

  const modalStyles = {
    background: 'rgba(255,255,255,0.45)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    borderRadius: isMobile ? 12 : 16,
    maxWidth: 420,
    width: isMobile ? '98vw' : '90vw',
    overflowY: 'auto',
    maxHeight: isMobile ? '92vh' : '90vh',
    boxSizing: 'border-box',
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    padding: isMobile ? '1rem 0.5rem' : '1.5rem 1rem 1rem 1rem',
    position: 'relative',
    border: '1px solid rgba(255,255,255,0.3)',
  };

  return (
    <div style={overlayStyles} onClick={onClose}>
      <div
        style={modalStyles}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: isMobile ? -2 : 12,
            right: isMobile ? 8 : 18,
            background: 'none',
            border: 'none',
            fontSize: isMobile ? '0.75rem' : '0.9rem',
            color: '#a97845',
            cursor: 'pointer',
            zIndex: 10,
            fontWeight: 700,
            transition: 'color 0.18s',
          }}
        >
          Close
        </button>
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Modal; 